import React from 'react';
import cn from 'classnames';
import Image from '@base/lib/ThemeImage';
import siteConf from 'pro/config/site';
import styles from './index.module.less';
import { Trans } from 'base/utils/i18n';

const stepImages = [
    'asset/width-192/picture/f908734c681677191b444e579e2f209f.png',
    'asset/width-192/picture/4edef173d1e92a44357fc2b50b141531.png',
    'asset/width-192/picture/ec7c27d7a3e250b843b7574a93e8bb04.png',
    'asset/width-192/picture/0d165bb5fe7acebeb730ec3e16691974.png'
]

const KlarnaSteps: React.FC<{ steps: string[] }> = ({ steps }) => {
    return (
        <div className={cn('flex', styles['after-pay-steps'])}>
            {steps.map((code, index) => {
                return (
                    <div key={index} className={cn('flex flex-middle', styles.step)}>
                        <div className={cn(styles.img)}>
                            <Image
                                src={stepImages[index] || ''}
                                alt={siteConf.brand}
                                width={64}
                                background={false}
                                fixed
                            />
                        </div>

                        <div className={styles.text}>
                            <Trans i18nKey={code}/>
                        </div>
                    </div>
                )
            })}
        </div>
    );
};

export default KlarnaSteps